export const errorsValidations = {
	anticipation: {
		value: {
			noLiquidValue: "Ingrese el valor neto para la anticipación",
			liquidValue:
				"Valor solicitado mayor que valor total neto disponible ({{totalAvailable}})",
			noTotalValue: "Ingrese el valor total a anticipar",
			totalValue:
				"Valor solicitado mayor que valor total bruto disponible ({{totalAvailable}})",
			reason: "Ingrese un motivo para la anticipación",
		},
		accountData: {
			noAccountType: "Seleccione un tipo de cuenta para la anticipación",
			accountHolder: "Ingrese el nombre del titular de la cuenta",
			accountTypeExisting: "Seleccione una de las cuentas existentes",
			accountName: "Ingrese el nombre para identificar la cuenta",
			accountBank: "Seleccione el banco al que pertenece la cuenta",
			accountDocument: "Ingrese el documento del titular de la cuenta (RFC)",
			accountDocumentInvalid: "Documento inválido",
			accountAgency: "Ingrese el número de la sucursal",
			accountAgencyInvalid: "Sucursal inválida",
			accountNumber: "Ingrese el número de la cuenta",
			accountDigit: "Ingrese el dígito de la cuenta",
			accountType: "Seleccione el tipo de la cuenta",
			accountPixKey: "Clave PIX inválida",
			accountTypeWrapper: "Complete los datos bancarios o clave PIX",
		},
	},
	withdraw: {
		value: {
			noWithdrawValue: "Ingrese el valor para el retiro",
			withdrawValue:
				"Valor solicitado mayor que valor total bruto disponible ({{totalAvailable}})",
			reason: "Ingrese un motivo para la solicitud",
			accountChoice: "Seleccione un tipo de cuenta para la solicitud",
			existingAccount: "Seleccione una de las cuentas existentes",
			accountName: "Ingrese el nombre para identificar la cuenta",
			accountHolder: "Ingrese el nombre del titular de la cuenta",
			accountBank: "Seleccione el banco al que pertenece la cuenta",
			accountNumber: "Ingrese el número de la cuenta",
			accountDigit: "Ingrese el dígito de la cuenta",
			agencyNumber: "Ingrese el número de la sucursal",
			agencyInvalid: "Sucursal inválida",
			documentNumber: "Ingrese el documento del titular de la cuenta (RFC)",
			documentInvalid: "Documento inválido",
			accountType: "Seleccione el tipo de la cuenta",
			pixKeyInvalid: "Clave PIX inválida",
			receiverDataWrapper: "Complete los datos bancarios o clave PIX",
		},
	},
	bankSlip: {
		basicInfoValue:
			"Valor solicitado mayor que valor total bruto disponible ({{totalAvailable}})",
		beneficiary: "Ingrese el beneficiario de la boleta",
		barCode: "Ingrese el código de barras de la boleta",
		invalidBarCode: "Código de barras inválido",
		attachment: "Anexe el archivo de la boleta",
		dueDate:
			"ATENCIÓN: La boleta solo será pagada si el saldo restante cubre los costos con intereses y multa.",
	},
};
